<template>
  <div class="page-wrapper">
    <div class="page-content">
      <!-- <div class="wrapper header">
        <img src="../assets/ic_logo_m.png" class="logo" />
      </div> -->

      <img src="../assets/bg_screenshot.png" class="bg_screenshot" />
      <div v-if="isIOS" class="download_group" @click="download">
        <img src="../assets/ic_download_ios.png" class="icon" />
        <span class="content">点击下载</span>
      </div>
      <div v-if="!isIOS" class="download_group" @click="download">
        <img src="../assets/ic_download_android.png" class="icon" />
        <span class="content">
          点击下载
          <span class="tip-text-highlight">微端包</span>
        </span>
        <span class="content" v-show="androidSize">{{ androidSize }}</span>
      </div>
      <div class="info">
        <dl>
          <br />
          <dd>微端包体秒速下载</dd>
          <dd>装备、战力、好友 精彩依旧</dd>
          <br />
          <dd>随时随地</dd>
          <dd>感受“征途”魅力</dd>
          <br />
        </dl>
        <br />
        <br />
      </div>
    </div>
    <div class="page-mask" v-if="showMask">
      <img class="img-arrow" src="../assets/ic_arrow.png" />
      <div class="tip-text-wrapper">
        <span>请点击右上角菜单</span>
        <br />
        <span>使用</span>
        <span class="tip-text-highlight">浏览器</span>
        <span>打开此页面</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Mobile",
  props: {
    androidUrl: String,
    iOSUrl: String,
    androidSize: String,
  },
  data() {
    return {
      isIOS: false,
      showMask: false,
    };
  },
  mounted() {
    var self = this;
    window.onresize = () => {
      return setTimeout(() => {
        self.refreshEnv();
      }, 300);
    };
    self.refreshEnv();
  },
  methods: {
    inIOS() {
      return navigator.userAgent.match(/iPad|iPod|iPhone/i) ? true : false;
    },
    inWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      // alert(ua)
      return ua.match(/MicroMessenger/i) == "micromessenger" ? true : false;
    },
    refreshEnv() {
      this.isIOS = this.inIOS();
    },
    download() {
      // if (this.inIOS()) {
      //   window.location.href = this.iOSUrl;
      // } else if (this.inWeiXin()) {
      //   // window.location.href = this.androidUrl;
      //   this.showMask = true;
      // } else {
      //   window.location.href = this.androidUrl;
      // }
      if (this.inWeiXin()) {
        this.showMask = true;
      } else {
        if (this.inIOS()) {
          window.location.href = this.iOSUrl;
        }else{
          window.location.href = this.androidUrl;
        }
      }
    },
    downloadPreview() {
      if (this.inWeiXin()) {
        // window.location.href = this.androidUrl;
        this.showMask = true;
      } else {
        window.location.href = this.androidPreviewUrl;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.expand {
  flex-grow: 1;
  flex: 1;
}

.wrapper {
  background-color: #333a42;
}

.wrapper.header,
.wrapper.header .logo {
  height: 3rem;

  background: #333a42;
}

.bg_screenshot {
  width: 60%;
  margin-top: 0.5rem;
  margin-bottom: 0.1rem;
}

.download_group {
  text-decoration: none;
  width: 10rem;
  margin: 0.5rem auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #999999;
  font-size: 0.3rem;
  padding: 0.5rem;
  text-align: center;
  border-radius: 0.5rem;
  background-color: #f0f0f0;
}

.download_group .icon {
  width: 10rem;
}

.btn {
  background-color: #515d6d;
}

.btn:active {
  background-color: #403d50;
}

.download_group .content {
  margin-top: 0.5rem;
  font-size: 0.8rem;
}

.info {
  text-align: left;
}

dl {
  margin-right: 2rem;
}

dt {
  font-size: 18px;
  font-weight: 700;
  margin-left: 2rem;
  margin-top: 1rem;
}

dd {
  font-size: 15px;
}
.page-content {
  position: absolute;
}
.page-mask {
  width: 100%;
  height: 100%;
  background-color: #333333ee;
  position: fixed;
  padding: 0px 0px 0px 0px;
  text-align: right;
}
.img-arrow {
  margin: 10px 20px 0px 0px;
}
.tip-text-wrapper {
  font-size: 18px;
  color: white;
  margin-right: 30px;
}
.tip-text-highlight {
  color: #ff5b42;
}
</style>
